<template>
  <div class="image-upload-box">
    <a-upload
      name="image"
      list-type="picture-card"
      :file-list="fileList"
      :headers="headers"
      :data="data"
      :action="uploadUrl"
      :before-upload="beforeUpload"
      @preview="handlePreview"
      @change="handleChange"
    >
      <div v-if="fileList.length < maxNum">
        <a-icon :type="loading ? 'loading' : 'upload'" />
        <div class="ant-upload-text">点击上传</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<style lang="less" scoped>
@import 'ImageUpload';
</style>

<script>
import ImageUpload from './ImageUpload'
export default ImageUpload
</script>
